const regExPassword = /^[0-9a-zA-Z]*$/
const regExPhotoNumber = /^[0-9a-zA-Z\-\n\r]+$/

export interface EventFields {
  password: string
  photoNumbers: string
}

export default class EventValidator {
  private fields: Partial<EventFields>

  constructor(fields: Partial<EventFields>) {
    this.fields = fields
  }

  isPasswordFormatValid(): boolean {
    return !!this.fields.password && regExPassword.test(this.fields.password)
  }

  isPasswordValid(): boolean {
    return !!this.fields.password && this.isPasswordFormatValid()
  }

  isPhotoNumberFormatValid(): boolean {
    return !!this.fields.photoNumbers && regExPhotoNumber.test(this.fields.photoNumbers)
  }

  isPhotoNumberLengthValid(): boolean {
    return !!this.fields.photoNumbers && this.fields.photoNumbers.split('\n').length < 61
  }
}
